export default "__VITE_ASSET__DPM7uEMC__"